const Main = () =>
    import ('@/views/main');
const storageIndex = () =>
    import ('@/views/storage');
const retail = () =>
    import ('@/views/storage/retail');
const food = () =>
    import ('@/views/storage/food');
const wareHouse = () =>
    import ('@/views/storage/wareHouse');
const tradeStock = () =>
    import ('@/views/storage/tradeStock');
const outbound = () =>
    import ('@/views/storage/outbound');
const allocate = () =>
    import ('@/views/storage/allocate');
const productDetail = () =>
    import ('@/views/storage/productDetail');
const stockTaking = () =>
    import ('@/views/storage/stockTaking');
const tradeRecord = () =>
    import ('@/views/storage/tradeRecord');
const stockTakeHistory = () =>
    import ('@/views/storage/stockTakeHistory');
const checkLogList = () =>
    import ('@/views/storage/checkLogList');
const storageSave = () =>
    import ('@/views/storage/storage-save');

export default [{
    path: '/storage',
    name: 'storage',
    redirect: '/storageIndex',
    component: Main,
    meta: {
        hide: false,
        name: '仓储管理',
        unfold: true,
		iconType: "9"
    },
    children: [{
            path: "/storageIndex",
            name: 'storageIndex',
            component: storageIndex,
            meta: {
                name: "仓库管理",
            },
            children: [{
                path: "wareHouse",
                name: 'wareHouse',
                component: wareHouse,
                meta: {
                    name: "仓库仓储"
                },
            }],
            children: [{
                path: "storageSave",
                name: 'storageSave',
                component: storageSave,
                meta: {
                    name: "仓库仓储"
                },
            }]
        },
        {
            path: "/retail",
            name: 'retail',
            component: retail,
            meta: {
                name: "零售仓储"
            },
            children: [{
                path: "tradeStock",
                name: 'tradeStock',
                component: tradeStock,
                meta: {
                    name: "商品入库"
                },
            }, {
                path: "outbound",
                name: 'outbound',
                component: outbound,
                meta: {
                    name: "出库申请"
                },
            }, {
                path: "allocate",
                name: 'allocate',
                component: allocate,
                meta: {
                    name: "调拨商品"
                },
            }, {
                path: "productDetail/:id/:storeageId",
                name: 'productDetail',
                component: productDetail,
                meta: {
                    name: "商品详情"
                },
                children: [
                    {
                        path: "tradeRecordDetail",
                        name: 'tradeRecordDetail',
                        component: tradeRecord,
                        meta: {
                            name: "商品出入库记录"
                        },
                    }
                ]
            }, {
                path: "stockTaking",
                name: 'stockTaking',
                component: stockTaking,
                meta: {
                    name: "库存盘点"
                },
                children: [
                    {
                        path: "stockTakeHistory",
                        name: 'stockTakeHistory',
                        component: stockTakeHistory,
                        meta: {
                            name: "进行盘点"
                        },
                    },
                    {
                        path: "checkLogList",
                        name: 'checkLogList',
                        component: checkLogList,
                        meta: {
                            name: "盘点详情"
                        },
                    },
                ]
            }, 
            {
                path: "tradeRecord",
                name: 'tradeRecord',
                component: tradeRecord,
                meta: {
                    name: "商品出入库记录"
                },
            }
        ]
        },
        // {
        //     path: "/food",
        //     name: 'food',
        //     component: food,
        //     meta: {
        //         name: "食材管理"
        //     }
        // },
    ]
}]